module.exports = __webpack_public_path__ + "static/media/panel.5d20a021.jpg";